<div *ngIf="nuevoObjetoAux.length>0"> 
    <ng-template ngFor let-room let-i="index" [ngForOf]="nuevoObjetoAux">
      <usb-hotel-room [room]='nuevoObjetoAux[i]'  [allRoom] = 'nuevoObjetoAux'  [images]="imgList" [select]="select" [index]="i" [productQty]="productQty"
        [reserveMultiHab]="hotel.additionalInfo.reserveMultiHab" (calculateTotalPrice)="calculateTotalPrice($event)">
      </usb-hotel-room>
    </ng-template>
  </div> 
